module.exports = __webpack_public_path__ + "img/pa-logo.39be0fe3.png";